import {merchDistributionTemplateFormToQuery as formToQuery } from './merchDistributionTemplateFormToQuery';
import {merchDistributionTemplateQueryToForm as queryToForm } from './merchDistributionTemplateQueryToForm';

export default { formToQuery, queryToForm };
